// removed by extract-text-webpack-plugin
module.exports = {"CustomizeTemplate":"CustomizeTemplate---iAwUf","CustomizeSidebar":"CustomizeSidebar---1IwOf","ExitButton":"ExitButton---dxkx1"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/Customize/CustomizeTemplate/style.styl
// module id = MdQU
// module chunks = 89